<template>
  <div id="bottomNavigation">
    <v-bottom-navigation
      v-show="showNavBar"
      :value="navBarActiveButton"
      fixed
      grow
      color="primary"
      style="height: auto"
    >
      <!-- 
        CHECK Button 
      -->
      <v-btn @click="$router.push('/seatavailability', () => {})">
        <span>Check</span>
        <v-icon>mdi-calendar-question</v-icon>
      </v-btn>

      <!-- 
        NEW Button 
      -->
      <v-btn @click="$router.push('/', () => {})">
        <span>New</span>
        <v-icon>mdi-calendar-plus</v-icon>
      </v-btn>

      <!-- 
        MY BOOKINGS Button 
      -->
      <v-btn @click="$router.push('/mybookings', () => {})">
        <span>My Bookings</span>
        <v-icon>mdi-calendar-star</v-icon>
      </v-btn>

      <!-- 
        ACCOUNT Button 
      -->
      <v-btn @click="$router.push('/account', () => {})">
        <span>Account</span>
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>

    </v-bottom-navigation>

    <v-bottom-navigation
      v-show="showQRCodeBar"
      :value="navQRCodeActiveButton"
      fixed
      grow
      color="primary"
      style="height: auto"
    >
      <span class="qrcode-bar-btm-wording">
        Scan the QR code to make a booking!
      </span>

      <v-img
        :src="`${iconPath}qrcode.png`"
        max-height="120"
        max-width="120"
      ></v-img>

    </v-bottom-navigation>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BottomNavigationBar",
  computed: {
    ...mapState(["showNavBar", "navBarActiveButton", "showQRCodeBar", "navQRCodeActiveButton"]),
  },
};
</script>

<style scoped>
  /* Fix bottom-navigation button floting up issue */
  #bottomNavigation .v-btn:not(.v-btn--round).v-size--default {
    height: auto;
  }

  #bottomNavigation,
  #bottomNavigation .v-icon {
    font-size: 20px;
  }

  #bottomNavigation .v-icon {
    margin-bottom: 2px;
  }

  #bottomNavigation .v-btn {
    padding-top: 7px;
    padding-bottom: 5px;
    background-color:white;
  }

  #bottomNavigation .v-item-group.v-bottom-navigation .v-btn {
    font-size: 12px !important;
  }

  .qrcode-bar-btm-wording {
    color     : black;
    margin    : auto 1.5rem;
    font-size : 1rem;
  }
</style>